export const CONSENT_KEY = 'faerdo.cookie-consent';
export type ConsentStatus = 'accepted' | 'declined';

type GtagArgs = [string, ...unknown[]];

declare global {
  interface Window {
    dataLayer: GtagArgs[];
    gtag: (...args: GtagArgs) => void;
  }
}

export function initAnalytics(measurementId: string): void {
  window.dataLayer = window.dataLayer ?? [];
  window.gtag = (...args: GtagArgs) => {
    window.dataLayer.push(args);
  };

  // Consent Mode v2 — deny everything by default
  window.gtag('consent', 'default', {
    analytics_storage: 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    wait_for_update: 500,
  });

  window.gtag('js', new Date());
  window.gtag('config', measurementId);

  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  script.async = true;
  document.head.appendChild(script);

  const stored = getStoredConsent();
  if (stored !== null) {
    applyConsent(stored);
  }
}

export function getStoredConsent(): ConsentStatus | null {
  return localStorage.getItem(CONSENT_KEY) as ConsentStatus | null;
}

export function applyConsent(status: ConsentStatus): void {
  localStorage.setItem(CONSENT_KEY, status);
  window.gtag?.('consent', 'update', {
    analytics_storage: status === 'accepted' ? 'granted' : 'denied',
  });
}

export function trackPageView(path: string): void {
  window.gtag?.('event', 'page_view', { page_path: path });
}
